<template>
    <div class="col-md-12">
        <div
            class="tab-pane fade show active"
            v-for="(gender, index) in product.gender_groups"
            :key="index"
            :id="index"
            role="tabpanel"
            :aria-labelledb="index + '-tab'"
            v-show="product.active_gender_index == index"
        >
            <div class="tab_pro_panel mt_20">
                <div
                    v-for="picked_color in gender.selected_colors"
                    :key="picked_color.id"
                    class="tabs_table d-md-flex size_color_table"
                >
                    <div class="available_color_columns">
                        <div
                            class="color d-flex align-items-center color_column"
                        >
                            <div
                                v-if="picked_color.hash"
                                class="color_box mr_10"
                                :style="'background: ' + picked_color.hash"
                            ></div>
                            <img
                                v-else
                                class="color_box mr_10"
                                :src="picked_color.swatches"
                            />
                            <h5 class="color-name">
                                {{ toTitleCase(picked_color.color_name) }} -
                                Sizes
                            </h5>
                        </div>
                    </div>
                    <div class="sizez_columns">
                        <div class="d-flex flex-wrap inner_size_table">
                            <div
                                class="product_count"
                                v-for="(gendersizes, indx) in picked_color[
                                    'unique_sizes'
                                ]"
                                :key="indx"
                            >
                                <div class="count_item_heading">
                                    <h6 class="m-0">
                                        {{ gendersizes.Size.size }}
                                    </h6>
                                    <span>
                                        {{
                                            icPriceFormat(
                                                getRetailPrice({
                                                    base_price: parseFloat(
                                                        gendersizes.price_base
                                                    ),
                                                    markup_price: parseFloat(
                                                        gendersizes.markup_price
                                                    ),
                                                    single_location_price:
                                                        parseFloat(
                                                            gendersizes.single_location_price ||
                                                                0
                                                        ),
                                                    color_category_price:
                                                        getDarkLightFees(
                                                            picked_color
                                                        ),
                                                    decoration_discount_percentage:
                                                        gendersizes.decoration_discount_percentage
                                                })
                                            )
                                        }}
                                    </span>
                                </div>
                                <div class="count_item_price">
                                    <input
                                        type="text"
                                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                        v-model="gendersizes.quantity"
                                        @change="
                                            calculatePricing(
                                                index,
                                                gendersizes,
                                                $event
                                            )
                                        "
                                        class="form-control"
                                        placeholder="0"
                                    />
                                </div>
                            </div>
                            <div class="product_count total_count">
                                <div class="count_item_heading">
                                    <h6 class="m-0">Total</h6>
                                </div>
                                <div class="count_item_price total_box">
                                    <input
                                        readonly
                                        type="text"
                                        :value="
                                            icPriceFormat(
                                                picked_color.total_cost_gender_wise
                                            )
                                        "
                                        class="form-control"
                                        placeholder="0"
                                    />
                                    <div
                                        class="dropdown"
                                        v-if="
                                            picked_color.total_qty_gender_wise >
                                            0
                                        "
                                    >
                                        <a
                                            href="javascript:void(0);"
                                            class="dropdown-toggle d-flex align-items-center"
                                            :id="
                                                'dropdownMenuButton' +
                                                picked_color.id
                                            "
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <img
                                                src="/maincss/images/path.png"
                                                class="ml_6 path"
                                            />
                                        </a>

                                        <div
                                            class="dropdown-menu drop-cart-menu drop_product"
                                            aria-labelledby="dropdownMenuButton"
                                        >
                                            <h4
                                                class="font_size_16 text_primary_blue py_2 px_20"
                                            >
                                                {{
                                                    toTitleCase(
                                                        picked_color.color_name
                                                    )
                                                }}
                                                <span class="cross_ic">
                                                    <img
                                                        src="/maincss/images/cross.svg"
                                                    />
                                                </span>
                                            </h4>
                                            <div class="scroll">
                                                <div>
                                                    <div class="col-md-12">
                                                        <div
                                                            class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                        >
                                                            <div
                                                                class="table-responsive"
                                                            >
                                                                <table
                                                                    width="100%"
                                                                    class="table-bordered comma-decimal-place table-data table-hover space_b"
                                                                >
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                Size
                                                                            </th>
                                                                            <th>
                                                                                Quantity
                                                                            </th>
                                                                            <th>
                                                                                Total
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            v-for="(
                                                                                size,
                                                                                ind
                                                                            ) in picked_color[
                                                                                'unique_sizes'
                                                                            ]"
                                                                            :key="
                                                                                ind
                                                                            "
                                                                            v-show="
                                                                                size.quantity >
                                                                                0
                                                                            "
                                                                        >
                                                                            <td
                                                                                class="size"
                                                                            >
                                                                                {{
                                                                                    size
                                                                                        .Size
                                                                                        .size
                                                                                }}
                                                                            </td>
                                                                            <td>
                                                                                {{
                                                                                    size.quantity
                                                                                }}
                                                                                *
                                                                                {{
                                                                                    icPriceFormat(
                                                                                        size.cost
                                                                                    )
                                                                                }}
                                                                            </td>
                                                                            <td>
                                                                                {{
                                                                                    icPriceFormat(
                                                                                        size.total_cost
                                                                                    )
                                                                                }}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div
                                                            class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                            v-if="
                                                                parseFloat(
                                                                    picked_color.total_design_fee
                                                                ) > 0
                                                            "
                                                        >
                                                            <p
                                                                class="font-weight-bold w-90 m-0"
                                                            >
                                                                Design Fee:
                                                            </p>
                                                            <p
                                                                class="ml-auto mb-0"
                                                            >
                                                                {{
                                                                    icPriceFormat(
                                                                        picked_color.total_design_fee
                                                                    )
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a href="javascript:void(0);" class="mt-1">
                        <img
                            @click="$emit('deleteColor', picked_color)"
                            src="/maincss/images/icons/delete_dark.svg"
                        />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ProductSizeQuantityInputs",
    props: {
        product: {
            type: Object,
            required: true
        },
        buildDetails: {
            type: Object
        },
        getMarkupFromTier: {
            type: Function,
            required: true,
            default: () => {}
        }
    },
    data() {
        return {
            max_cart_count: 2000,
            design_fee: 0,
            setup_fee: 0,
            setup_fee_applied_gender_index: -1
        };
    },
    methods: {
        calculatePricing(index, size, event = null) {
            var _this = this;
            if (_this.product.decoration_type == 1) {
                _this.calculatePrintPricing(index);
            } else if (_this.product.decoration_type == 2) {
                _this.calculateEmbroideryPricing(index);
            }

            // Check Qty
            let total_qty = 0;
            _this.product.gender_groups.forEach((csq) => {
                total_qty = total_qty + csq.total_qty_gender_wise;
            });
            _this.disable_btns = total_qty == 0;

            this.$forceUpdate();
            this.$emit("updateParentDom");
        },

        calculatePrintPricing(index) {
            let gender_element = this.product.gender_groups[index];

            gender_element.total_discount_value = 0;
            gender_element.total_qty_gender_wise = 0;
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0;
            gender_element.total_dark_category_fee = 0;
            gender_element.total_light_category_fee = 0;
            gender_element.subtotal = 0;
            this.setup_fee = 0;
            /* eslint-disable */
            if (gender_element["selected_colors"]) {
                let single_location_price = this.getDecorationPrice();
                gender_element["selected_colors"].forEach(
                    (selected_color_obj) => {
                        selected_color_obj.total_discount_value = 0;
                        selected_color_obj.total_qty_gender_wise = 0;
                        selected_color_obj.total_cost_gender_wise = 0;
                        selected_color_obj.total_design_fee = 0;
                        selected_color_obj.total_color_fee = 0;
                        selected_color_obj.total_dark_category_fee = 0;
                        selected_color_obj.total_light_category_fee = 0;
                        selected_color_obj.setup_fee = 0;
                        selected_color_obj.subtotal = 0;

                        selected_color_obj["unique_sizes"].forEach((size) => {
                            if (
                                this.product.decoration_price_type ==
                                "global_price"
                            ) {
                                this.product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        this.product.price_base,
                                        this.product.decoration_type,
                                        this.product.decoration_price_template
                                    );
                                this.product.price_markup_value =
                                    (parseFloat(this.product.price_base) *
                                        parseFloat(
                                            this.product.price_markup_percentage
                                        )) /
                                    100;
                            }

                            let base_price = this.product.price_base;
                            let mark_up_cost = this.product.price_markup_value;
                            if (parseFloat(size.price_base) > 0) {
                                base_price = parseFloat(size.price_base);
                                size.markup_percentage =
                                    this.product.price_markup_percentage;
                                if (
                                    this.product.decoration_price_type ==
                                    "global_price"
                                ) {
                                    size.markup_percentage =
                                        this.getMarkupFromTier(
                                            base_price,
                                            this.product.decoration_type,
                                            this.product
                                                .decoration_price_template
                                        );
                                }
                                mark_up_cost =
                                    (base_price * size.markup_percentage) / 100;
                            }

                            size.markup_price = mark_up_cost;

                            let color_category_price = 0;
                            if (selected_color_obj.category == "Dark") {
                                color_category_price =
                                    this.product.price_color_category_dark;
                                size.dark_price = color_category_price;
                                selected_color_obj.total_dark_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                                gender_element.total_dark_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                            } else if (selected_color_obj.category == "Light") {
                                color_category_price =
                                    this.product.price_color_category_light;
                                size.light_price = color_category_price;
                                selected_color_obj.total_light_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                                gender_element.total_light_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                            }

                            size.ink_price = parseFloat(color_category_price);
                            size.single_location_price = single_location_price;
                            if (
                                size.quantity != "undefined" &&
                                size.quantity > 0
                            ) {
                                size.cost = this.getRetailPrice({
                                    base_price: parseFloat(base_price),
                                    markup_price: parseFloat(mark_up_cost),
                                    single_location_price: parseFloat(
                                        size.single_location_price
                                    ),
                                    color_category_price:
                                        parseFloat(color_category_price)
                                });

                                if (this.product.NewProductDiscount !== null) {
                                    let discount_type =
                                        this.product.NewProductDiscount
                                            .discount_type;
                                    let discount_value = parseFloat(
                                        this.product.NewProductDiscount
                                            .discount_value
                                    );
                                    let single_quantity_discount = 0;
                                    if (discount_type == "Percent") {
                                        single_quantity_discount =
                                            (size.cost * discount_value) / 100;
                                        size.discount =
                                            single_quantity_discount *
                                            parseInt(size.quantity);
                                    } else {
                                        single_quantity_discount =
                                            discount_value;
                                        size.discount =
                                            single_quantity_discount *
                                            parseInt(size.quantity);
                                    }
                                    selected_color_obj.total_discount_value +=
                                        parseFloat(size.discount);
                                    selected_color_obj.total_discount_value =
                                        parseFloat(
                                            selected_color_obj.total_discount_value
                                        );
                                    size.cost =
                                        size.cost - single_quantity_discount;
                                }

                                if (size.quantity > 0) {
                                    size.total_cost =
                                        this.icPriceFormat(size.cost, true) *
                                        parseInt(size.quantity);
                                    selected_color_obj.subtotal += parseFloat(
                                        size.total_cost
                                    );
                                    selected_color_obj.total_cost_gender_wise +=
                                        size.total_cost;
                                    selected_color_obj.total_qty_gender_wise +=
                                        parseInt(size.quantity);
                                }
                            }
                        });

                        // selected_color_obj.imprint_locations = this.imprint_locations;

                        selected_color_obj.total_cost_gender_wise += parseFloat(
                            selected_color_obj.total_design_fee
                        );

                        gender_element.subtotal += parseFloat(
                            selected_color_obj.subtotal
                        );
                        gender_element.total_discount_value += parseFloat(
                            selected_color_obj.total_discount_value
                        );
                        gender_element.total_design_fee += parseFloat(
                            selected_color_obj.total_design_fee
                        );
                        gender_element.total_qty_gender_wise += parseFloat(
                            selected_color_obj.total_qty_gender_wise
                        );
                        gender_element.total_cost_gender_wise += parseFloat(
                            selected_color_obj.total_cost_gender_wise
                        );
                    }
                );
            }

            this.product.gender_groups[index] = gender_element;
            /* eslint-enable */
        },

        calculateEmbroideryPricing(index) {
            let gender_element = this.product.gender_groups[index];

            gender_element.total_discount_value = 0;
            gender_element.total_qty_gender_wise = 0;
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0;
            gender_element.total_dark_category_fee = 0;
            gender_element.total_light_category_fee = 0;
            gender_element.total_decoration_discount_value = 0;
            gender_element.subtotal = 0;
            this.setup_fee = 0;
            /* eslint-disable */
            if (gender_element["selected_colors"]) {
                let single_location_price = this.getDecorationPrice();
                gender_element["selected_colors"].forEach(
                    (selected_color_obj) => {
                        selected_color_obj.total_discount_value = 0;
                        selected_color_obj.total_qty_gender_wise = 0;
                        selected_color_obj.total_cost_gender_wise = 0;
                        selected_color_obj.total_design_fee = 0;
                        selected_color_obj.total_color_fee = 0;
                        selected_color_obj.total_dark_category_fee = 0;
                        selected_color_obj.total_light_category_fee = 0;
                        selected_color_obj.total_decoration_discount_value = 0;
                        selected_color_obj.setup_fee = 0;
                        selected_color_obj.subtotal = 0;
                        selected_color_obj["unique_sizes"].forEach((size) => {
                            if (
                                this.product.decoration_price_type ==
                                "global_price"
                            ) {
                                this.product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        this.product.price_base,
                                        this.product.decoration_type,
                                        this.product.decoration_price_template
                                    );
                                this.product.price_markup_value =
                                    (parseFloat(this.product.price_base) *
                                        parseFloat(
                                            this.product.price_markup_percentage
                                        )) /
                                    100;
                            }

                            let base_price = this.product.price_base;
                            let mark_up_cost = this.product.price_markup_value;
                            if (parseFloat(size.price_base) > 0) {
                                base_price = parseFloat(size.price_base);
                                size.markup_percentage =
                                    this.product.price_markup_percentage;
                                if (
                                    this.product.decoration_price_type ==
                                    "global_price"
                                ) {
                                    size.markup_percentage =
                                        this.getMarkupFromTier(
                                            base_price,
                                            this.product.decoration_type,
                                            this.product
                                                .decoration_price_template
                                        );
                                }
                                mark_up_cost =
                                    (base_price * size.markup_percentage) / 100;
                            }

                            size.markup_price = mark_up_cost;

                            let color_category_price = 0;
                            if (selected_color_obj.category == "Dark") {
                                color_category_price =
                                    this.product.price_color_category_dark;
                                size.dark_price = color_category_price;
                                selected_color_obj.total_dark_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                                gender_element.total_dark_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                            } else if (selected_color_obj.category == "Light") {
                                color_category_price =
                                    this.product.price_color_category_light;
                                size.light_price = color_category_price;
                                selected_color_obj.total_light_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                                gender_element.total_light_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                            }

                            size.ink_price = parseFloat(color_category_price);
                            size.single_location_price = parseFloat(
                                single_location_price
                            );
                            size.decoration_discount_percentage =
                                this.getDecorationDiscount();
                            if (
                                size.quantity != "undefined" &&
                                size.quantity > 0
                            ) {
                                size.cost = this.getRetailPrice({
                                    base_price: parseFloat(base_price),
                                    markup_price: parseFloat(mark_up_cost),
                                    single_location_price: parseFloat(
                                        single_location_price
                                    ),
                                    color_category_price:
                                        parseFloat(color_category_price),
                                    decoration_discount_percentage: parseFloat(
                                        size.decoration_discount_percentage
                                    ) // percentage%
                                });

                                // SALE DISCOUNT
                                if (this.product.NewProductDiscount !== null) {
                                    let discount_type =
                                        this.product.NewProductDiscount
                                            .discount_type;
                                    let discount_value = parseFloat(
                                        this.product.NewProductDiscount
                                            .discount_value
                                    );
                                    let single_quantity_discount = 0;
                                    if (discount_type == "Percent") {
                                        single_quantity_discount =
                                            (parseFloat(size.cost) *
                                                discount_value) /
                                            100;
                                        size.discount =
                                            single_quantity_discount *
                                            parseInt(size.quantity);
                                    } else {
                                        single_quantity_discount =
                                            discount_value;
                                        size.discount =
                                            single_quantity_discount *
                                            parseInt(size.quantity);
                                    }
                                    selected_color_obj.total_discount_value +=
                                        parseFloat(size.discount);
                                    selected_color_obj.total_discount_value =
                                        parseFloat(
                                            selected_color_obj.total_discount_value
                                        );
                                    size.cost -= single_quantity_discount;
                                }

                                size.decoration_discount_value = 0;
                                if (size.quantity > 0) {
                                    if (size.decoration_discount_percentage) {
                                        size.decoration_discount_value =
                                            (this.icPriceFormat(
                                                size.cost,
                                                true
                                            ) *
                                                size.decoration_discount_percentage) /
                                            100;
                                    }
                                    size.total_cost =
                                        this.icPriceFormat(size.cost, true) *
                                        parseInt(size.quantity);
                                    selected_color_obj.subtotal += parseFloat(
                                        size.total_cost
                                    );
                                    selected_color_obj.total_cost_gender_wise +=
                                        size.total_cost;
                                    selected_color_obj.total_decoration_discount_value +=
                                        parseFloat(
                                            size.decoration_discount_value
                                        ) * parseInt(size.quantity);
                                    selected_color_obj.total_qty_gender_wise +=
                                        parseInt(size.quantity);
                                }
                            }
                        });

                        if (selected_color_obj.total_qty_gender_wise > 0) {
                            selected_color_obj.total_design_fee =
                                this.design_fee;
                        }

                        selected_color_obj.total_cost_gender_wise += parseFloat(
                            selected_color_obj.total_design_fee
                        );

                        gender_element.subtotal += parseFloat(
                            selected_color_obj.subtotal
                        );
                        gender_element.total_discount_value += parseFloat(
                            selected_color_obj.total_discount_value
                        );
                        gender_element.total_decoration_discount_value +=
                            parseFloat(
                                selected_color_obj.total_decoration_discount_value
                            );
                        gender_element.total_design_fee += parseFloat(
                            selected_color_obj.total_design_fee
                        );
                        gender_element.total_qty_gender_wise += parseFloat(
                            selected_color_obj.total_qty_gender_wise
                        );
                        gender_element.total_color_fee += parseFloat(
                            selected_color_obj.total_color_fee
                        );
                        gender_element.total_cost_gender_wise += parseFloat(
                            selected_color_obj.total_cost_gender_wise
                        );
                    }
                );
            }
            this.product.gender_groups[index] = gender_element;
            /* eslint-enable */
        },

        getTotalItemQuantity(gender_element) {
            let total_quantity = 0;
            gender_element.selected_colors.forEach((color) => {
                color.unique_sizes.forEach((size) => {
                    if (size.quantity > 0) {
                        total_quantity += parseInt(size.quantity);
                    }
                });
            });
            return total_quantity;
        },

        getDecorationPrice(
            colorIndex = 0,
            locationIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;

            let total_quantity = this.getTotalItemQuantity(
                this.product.gender_groups[this.product.active_gender_index]
            );

            this.buildDetails.OrderBuildItems.forEach((item) => {
                total_quantity += parseInt(item.color_data.total_quantity);
            });

            if (this.product.decoration_type == 1) {
                let decoration_data;

                if (!additional) {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location2;
                }

                let total_group_quantity = parseInt(total_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity <= total_group_quantity ||
                        index == 0
                    ) {
                        qty_wise_color_price =
                            element[`colour${colorIndex + 1}`];
                    }
                }
            } else if (this.product.decoration_type == 2) {
                let decoration_data = this.product.price_decoration_bulk;
                let total_group_quantity = parseInt(total_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity1 <= total_group_quantity ||
                        index == 0
                    ) {
                        if (locationIndex > 0) {
                            qty_wise_color_price =
                                element[`location${locationIndex + 1}`];
                        } else {
                            qty_wise_color_price = element["cost"];
                        }
                    }
                }
            }

            return parseFloat(qty_wise_color_price || 0);
        },

        getDecorationDiscount(additional = false) {
            let discount = 0;

            let total_quantity = this.getTotalItemQuantity(
                this.product.gender_groups[this.product.active_gender_index]
            );

            this.buildDetails.OrderBuildItems.forEach((item) => {
                total_quantity += parseInt(item.color_data.total_quantity);
            });

            if (this.product.decoration_type == 1) {
                let decoration_data;

                if (!additional) {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location2;
                }

                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity <= total_quantity || index == 0) {
                        discount = element["discount"];
                    }
                }
            } else if (this.product.decoration_type == 2) {
                let decoration_data = this.product.price_decoration_bulk;
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity1 <= total_quantity || index == 0) {
                        discount = element["discount"];
                    }
                }
            }

            return parseFloat(discount || 0);
        },

        getRetailPrice(prices) {
            let item_price = 0;
            if (prices.base_price) {
                item_price += parseFloat(prices.base_price);
            }

            if (prices.markup_price) {
                item_price += parseFloat(prices.markup_price);
            }

            if (prices.single_location_price) {
                item_price += parseFloat(prices.single_location_price);
            }

            if (prices.color_category_price) {
                item_price += parseFloat(prices.color_category_price);
            }

            if (prices.decoration_discount_percentage) {
                let decoration_discount_value =
                    (this.icPriceFormat(item_price, true) *
                        parseFloat(prices.decoration_discount_percentage)) /
                    100;
                item_price -= parseFloat(decoration_discount_value);
            }

            return item_price;
        },

        getDarkLightFees(color) {
            if (color) {
                if (color.category == "Dark") {
                    return parseFloat(this.product.price_color_category_dark);
                } else if (color.category == "Light") {
                    return parseFloat(this.product.price_color_category_light);
                }
            }

            return 0;
        }
    }
};
</script>
